<div class="home">

    <div class="home__top">
        <div class="home__top--title">
            <span class="home__top--title__text">{{LANGUAGES_MAP_LOCALIZED.get(selectedLanguage)}} Keywords</span>
            <span class="home__top--title__sub-text">Showing {{filteredKeywordsAndDefinitions.items.length}} keywords</span>
        </div>
        <div class="home__top--actions">
            <!-- Search Component -->
            <app-search
                [width]="'300px'"
                [placeholder]="SEARCH_PLACEHOLDER_LOCALIZED"
                (search)="search($event)">
            </app-search>
            <!-- Filter -->
            <button class="home__top--actions__button" #filterTrigger mat-flat-button (click)="openFilterDrawer(true); $event.stopPropagation()">
                <mat-icon>filter_list</mat-icon>
                <span i18n="Filters word translation|Translation for the word Filters@@Filters">Filters</span>
            </button>
            <!-- Filter Drawer -->
            <app-drawer #filterDrawer [trigger]="filterTrigger" [(opened)]="filterDrawerOpened">
                <!-- Filter Drawer Title -->
                <ng-container title>
                    <span class="filter__title">
                        <mat-icon>filter_list</mat-icon>
                        <span i18n="Filters word translation|Translation for the word Filters@@Filters">Filters</span>
                        &nbsp;
                        <span>({{ filterDrawerState.selectedTags.length }})</span>
                    </span> 
                </ng-container>
                <!-- Filter Content -->
                <div class="filter__item">
                    <!-- Tags -->
                    <p class="filter__item--title" i18n="Tags word translation|Translation for the word Tags@@Tags">Tags</p>
                    <div class="filter__item--inner" *ngFor="let tag of tags">
                        <mat-checkbox [checked]="filterDrawerState.selectedTags.includes(tag)" (change)="filterTagsHandle(tag, $event)"></mat-checkbox>
                        <span>{{ tag }}</span>
                    </div>
                </div>
                <!-- Filter Action Buttons -->
                <ng-container uiDrawerActions>
                    <button mat-flat-button class="filter__action-button" color="primary" (click)="applyFilters()" i18n="Apply Filters button label|Button label for applying the selected filter@@appApplyFilterInConfigPage">
                        Apply Filters
                    </button>
                    <button mat-flat-button class="filter__action-button" (click)="resetFilters()" i18n="Reset Filters button label|Button label for resetting the selected filter@@appResetFilterInConfigPage">
                        Reset Filters
                    </button>
                </ng-container>
            </app-drawer>
            <!-- Language Selected -->
            <mat-select 
                class="home__top--actions__locale-selected"
                [ngModel]="selectedLanguage" 
                (ngModelChange)="changeLanguage($event)"
                [hideSingleSelectionIndicator]="true"
            >
                <ng-container *ngFor="let languageCode of languageCodes">
                    <mat-option class="home__top--actions__locale-selected--option" [value]="languageCode">
                        <span><strong>{{LANGUAGES_MAP_LOCALIZED.get(languageCode)!}}</strong></span>
                    </mat-option>
                </ng-container>
            </mat-select>
            <!-- Create Dialog -->
            <button class="home__top--actions__button" mat-flat-button (click)="openCreateDialog();">
                <mat-icon>add</mat-icon>
                <span i18n="Create word translation|Translation for the word Create@@Create">Create</span>
            </button>
        </div>
    </div>

    <div class="home__main">
        <!-- Table -->
        <div class="home__main--table">
            <!-- Header -->
            <app-table-row
                class="home__main--table__row"
                [isHeader]="true"
            >
                <!-- Keywords -->
                <span>Keywords</span>
                <!-- Definition -->
                <span>Definition</span>
                <!-- Tags -->
                <span>Tags</span>
            </app-table-row>
            <!-- Rows -->
            <ng-container *ngFor="let keywordWithDefinition of filteredKeywordsAndDefinitions.items">
                <app-table-row
                    class="home__main--table__row"
                    [isHeader]="false"
                    [hasOptionalMenuAction]="true"
                    [optionalMenuAction]="keywordsTableMenu"
                    [optionalMenuActionData]="{ keywordWithDefinition }"
                >
                    <!-- Keywords -->
                    <span>{{keywordWithDefinition.keyword}}</span>
                    <!-- Definition -->
                    <span>{{keywordWithDefinition.definition}}</span>
                    <!-- Tags -->
                    <span>{{keywordWithDefinition.tag}}</span>
                </app-table-row>
            </ng-container>
        </div>
        <!-- Pagination -->
        <div class="home__main--table__paginator" i18n>
            <mat-paginator 
                [length]="filteredKeywordsAndDefinitions.totalItems"
                [pageSize]="filter.pageSize"
                [pageSizeOptions]="[5, 10, 30]"
                [pageIndex]="filter.pageIndex"
                (page)="changePage($event)"
            />
        </div>
    </div>
</div>
<!-- Table Menu Options -->
<mat-menu class="home__main--table__menu" #keywordsTableMenu="matMenu">
    <ng-template matMenuContent let-keywordWithDefinition="keywordWithDefinition">
        <!-- Edit Keyword -->
        <button mat-menu-item (click)="editKeyword(keywordWithDefinition)">
            <mat-icon>edit</mat-icon>
            <span i18n="Edit Keyword Option Label|Label text for edit keyword option@@EditKeyword">Edit Keyword</span>
        </button>
        <!-- Delete Keywords -->
        <button class="home__main--table__menu--delete" mat-menu-item (click)="deleteKeyword(keywordWithDefinition)">
            <mat-icon color="accent">delete</mat-icon>
            <span i18n="Delete Keyword Option Label|Label text for deleting keyword option@@DeleteKeyword">Delete Keyword</span>
        </button>
    </ng-template>
</mat-menu>